// Deferred callback to execute in a new cycle, or immediately
export const deferredCallback = (
    defer: boolean = false,
    callback: () => void,
) => {
    if (defer) {
        setTimeout(() => {
            callback();
        }, 1);
    } else {
        callback();
    }
};
